import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ChevronLeft } from "lucide-react";
import VoedingSection from "./VoedingSection";
import BottomNav from "../../components/ui/BottomNav";

export default function VoedingPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="max-w-2xl mx-auto px-4 pt-5 pb-28">
        <button onClick={() => navigate("/account")}
          className="flex items-center gap-2 text-zinc-500 hover:text-white text-sm font-semibold mb-6 transition-colors">
          <ChevronLeft size={16} /> Profiel
        </button>
        <h1 className="text-white font-black text-2xl mb-6">Voeding</h1>
        <VoedingSection user={user} />
      </div>
      <BottomNav />
    </div>
  );
}
